import TweetImporter from '#app/components/tweetImporter/tweetImporter.tsx'

export default function tweetImporter() {
	return <TweetImporter />
}
